import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import { StyrBadge } from '../../../connectors/products/StyrBadge';
import SettingsCollection, { ArchiveRestoreMutationTuple } from '../../generic/SettingsCollection';

export default function CompetenciesListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useCompetenciesQuery}
			lazyQuery={graphql.useCompetenciesLazyQuery}
			field="competencies"
			translationKey="settings.competencies"
			title={(competency: graphql.Competency) => localize(competency.title).text}
			link={(competency) => `/settings/competencies/${competency.id}`}
			titleBadge={(competency: graphql.Competency) =>
				competency.styrSkillID ? <StyrBadge rightAligned /> : null
			}
			variables={{}}
			archive={graphql.useArchiveCompetencyMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreCompetencyMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/competencies/new')}
		/>
	);
}
